var map = {
	"./Cafe_1.png": 1319,
	"./Cafe_2.png": 1320,
	"./Cafe_3.png": 1321,
	"./Cafe_4.png": 1322,
	"./Cafe_5.png": 1323,
	"./Cafe_6.png": 1324,
	"./Cafe_7.png": 1325
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1318;


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/cafe ^\.\/Cafe_.*\.png$
// module id = 1318
// module chunks = 3